"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.semanticKernelProvider = void 0;
const io_convention_1 = require("../../io-convention");
const json_1 = require("../../../core/utils/json");
/**
 * Semantic Kernel convention. SK logs whole messages as OTel GenAI event
 * payloads under a `gen_ai.event.content` key (a JSON string); the actual
 * message is nested under `message` or is the decoded payload itself.
 */
function unwrapSemanticKernelEnvelope(value, fallbackRole, ctx) {
    const content = (0, json_1.parseRecord)(value["gen_ai.event.content"]);
    if (!content)
        return io_convention_1.unmatched;
    return (0, io_convention_1.claimed)(ctx.normalizeMessage((0, json_1.asRecord)(content.message) ?? content, fallbackRole));
}
exports.semanticKernelProvider = {
    name: "semantic-kernel",
    tryUnwrapMessage: unwrapSemanticKernelEnvelope,
};
